import { createStore } from 'satcheljs';
import type { WacPrefetchResourcesStore } from './schema/WacPrefetchResourcesStore';
import { OfficeOnlineApp } from 'owa-file';

const defaultStore: WacPrefetchResourcesStore = {
    appsPreloaded: {
        [OfficeOnlineApp.Word]: false,
        [OfficeOnlineApp.Excel]: false,
        [OfficeOnlineApp.PowerPoint]: false,
    },
};

export const getStore = createStore('wacPrefetchResourcesStore', defaultStore);
